import { render } from "./AposContextMenuDialog.vue?vue&type=template&id=35432528"
import script from "./AposContextMenuDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./AposContextMenuDialog.vue?vue&type=script&setup=true&lang=js"

import "./AposContextMenuDialog.vue?vue&type=style&index=0&id=35432528&lang=scss"

import exportComponent from "../../../../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"ui/ui/apos/components/AposContextMenuDialog.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "35432528"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('35432528', __exports__)) {
    api.reload('35432528', __exports__)
  }
  
  module.hot.accept("./AposContextMenuDialog.vue?vue&type=template&id=35432528", () => {
    api.rerender('35432528', render)
  })

}


export default __exports__